import { render } from "./ContentHeader.vue?vue&type=template&id=2f0b6d3b&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"

import "./ContentHeader.vue?vue&type=style&index=0&id=2f0b6d3b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0b6d3b"],['__file',"src/components/report/ContentHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f0b6d3b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f0b6d3b', __exports__)) {
    api.reload('2f0b6d3b', __exports__)
  }
  
  module.hot.accept("./ContentHeader.vue?vue&type=template&id=2f0b6d3b&scoped=true", () => {
    api.rerender('2f0b6d3b', render)
  })

}


export default __exports__